<template>
    <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3">
        <form class="form-horizontal">
            <div class="overflow-auto ts-max-h-40" style="min-height: 400px">
                <div class="table-ui-detail">
                    <table class="ts-w-full">
                        <thead>
                            <tr>
                                <th class="ts-text-center" style="width: 2%">
                                    {{ $t("no") }}
                                </th>
                                <th class="ts-text-left" style="width: 20%">
                                    {{ $t("serviceTicket.repairProduct") }}
                                    <span class="ts-text-red-600">*</span>
                                </th>
                                <th class="ts-text-left" style="width: 20%">
                                    {{ $t("serviceTicket.serial") }}
                                </th>
                                <th class="ts-text-center required" style="width: 150px">
                                    {{ $t("serviceTicket.uom") }}
                                    <span class="ts-text-red-600">*</span>
                                </th>
                                <th class="ts-text-center required" style="width: 150px">
                                    {{ $t("serviceTicket.qty") }}
                                    <span class="ts-text-red-600">*</span>
                                </th>
                                <th class="ts-text-left">
                                    {{ $t("serviceTicket.remarks") }}
                                </th>
                                <th class="ts-text-center" style="width: 2%">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="model.product_list == 0">
                                <td colspan="9" class="ts-text-center ts-p-3 ts-space-x-1">
                                    <i class="fa fa-folder-open ts-text-gray-200"></i>
                                    <label class="ts-text-gray-400">
                                        {{ $t('noData') }}
                                    </label>
                                    <div class="validate ts-text-left" v-if="errors.has('product_list')">
                                        {{ errors.first('product_list') }}
                                    </div>
                                </td>
                            </tr>
                            <tr v-for="(item, index) in model.product_list" :key="index">
                                <td>
                                    <input type="text" :value="index + 1"
                                        class="ts-w-full ts-outline-none ts-text-center" readonly />
                                </td>
                                <td>
                                    <a-select v-model="item.product_id" :options="products" showSearch
                                        option-filter-prop="children" class="ts-w-full" :class="{
                                            'is-invalid': errors.has(
                                                'product_list.' +
                                                index +
                                                '.product_id'
                                            )
                                        }" placeholder="Select" style="min-width: 75px;" @change="onChangeProduct"
                                        @search="handleSearchProduct"></a-select>
                                </td>
                                <td>
                                    <a-select v-model="item.serial_no" :options="getSerials(item.product_id)" allowClear
                                        show-search option-filter-prop="children" class="ts-w-full"
                                        :class="{ 'is-invalid': errors.has('serial_no') }" placeholder="Select"
                                        @search="(value) => handleSearchSerial(value, item)" :loading="serial_searching"
                                        @change="(value) => onChangeSerial(value, item)"></a-select>
                                </td>
                                <td>
                                    <a-select v-model="item.uom_id" :options="getUom(item.product_id)" class="ts-w-full"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'product_list.' +
                                                index +
                                                '.uom_id'
                                            )
                                        }" placeholder="Select" style="min-width: 75px;"></a-select>
                                </td>
                                <td>
                                    <input type="number" v-model.number="item.quantity"
                                        class="form-control ts-text-center" :class="{
                                            'is-invalid': errors.has(
                                                'product_list.' +
                                                index +
                                                '.quantity'
                                            )
                                        }" placeholder="Qty" />
                                </td>
                                <td>
                                    <input type="text" v-model="item.remarks" :placeholder="$t('serviceTicket.remarks')"
                                        class="form-control" />
                                </td>
                                <td class="ts-text-center ts-align-middle">
                                    <span class="ts-whitespace-no-wrap ts-space-x-2">
                                        <a href="#" class="ts-text-blue" @click.prevent="addNewProduct(item)">
                                            <i class="fas fa-plus" v-tooltip="$t('serviceTicket.addNewProduct')"></i>
                                        </a>
                                        <a href="#" class="text-danger" @click.prevent="removeItem(item)">
                                            <i class="fa fa-trash" v-tooltip="$t('delete')"></i>
                                        </a>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="9" style="border-color: transparent !important;padding-left: 0;">
                                    <a-button type="primary" size="small" @click="addNewItem">
                                        <i class="fas fa-plus ts-text-xs ts-pr-1"></i>
                                        {{ $t('addItem') }}
                                    </a-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </form>
        <!-- form-action -->
        <a-modal v-if="show_form" v-model="show_form" :footer="null" width="60%"
            :title="$t('serviceTicket.addNewProduct')">
            <FormAddNewProduct ref="form" @cancel="() => show_form = false" @setProduct="setProduct" />
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Errors } from "form-backend-validation";
import { clone } from "lodash";
import FormAddNewProduct from "./form-add-new-product.vue";
import { debounce } from "lodash";

export default {
    name: "ItemDetails",
    props: ["value", "validate"],
    components: {
        FormAddNewProduct
    },
    data() {
        return {
            errors: new Errors(),
            show_form: false,
            serial_searching: false,
            product_searching: false,
            item: {},
            model: {},
            newItem: {
                product_id: null,
                serial_no: null,
                uom_id: null,
                quantity: 1,
                // warranty_expiry_date: null,
                repaired_by: null,
                purchase_from: null,
                // completion_date: null,
                remarks: null
            }
        };
    },
    created() {
        this.model = this.value;
    },
    computed: {
        ...mapState("customerService/serviceTicket", ["formViewDatas"]),
        products() {
            if (this.formViewDatas.products) {
                return this.formViewDatas.products.map(el => ({
                    value: el.product_id,
                    label: el.product_name_en,
                    barcode: el.barcode,
                    uom_cat_id: el.uom_cat_id,
                    uom_category: el.uom_category,
                }));
            }
            return [];
        },
        serials() {
            if (this.formViewDatas.serials) {
                return this.formViewDatas.serials.map(el => ({
                    value: el.serial_no,
                    label: el.serial_no + ' | ' + el.imei,
                    product_id: el.product_id,
                    purchase_from: el.purchase_from,
                    details: el
                }))
            }
            return []
        },
        uom() {
            if (this.formViewDatas.uom) {
                return this.formViewDatas.uom.map(el => ({
                    value: el.uom_id,
                    label: el.uom_name_en,
                    is_default: el.is_default,
                    stockout_quantity: el.stockout_quantity,
                    uom_cat_id: el.uom_cat_id,
                }));
            }
            return [];
        },
        employees() {
            if (this.formViewDatas.products) {
                return this.formViewDatas.employees.map(el => ({
                    value: el.employee_id,
                    label: el.employee_name_en
                }));
            }
        },
        chargeStatus() {
            return [
                {
                    value: 'pending',
                    label: 'Pending'
                },
                {
                    value: 'charged',
                    label: 'Charged'
                },
                {
                    value: 'free',
                    label: 'Free'
                },
            ];
        },
    },
    methods: {
        ...mapActions('customerService/serviceTicket', ['getFormViewModel']),
        onChangeProduct(value) {
            let uom_id = this.products
                .find(p => p.value == value).uom_category.unit_of_measures
                .find(el => el.is_default == true).uom_id;

            this.model.product_list.find(
                el => el.product_id == value
            ).uom_id = uom_id;

            this.getFormViewModel({
                index: 'serials',
                params: {
                    fnName: 'serials',
                    product_id: this.model.product_list.map(el => el.product_id)
                }
            })
        },
        onChangeSerial(value, item) {
            let serials = this.serials
                .find(p => p.value == value);
            item.purchase_from = serials ? serials.purchase_from : ''
        },
        handleSearchProduct: debounce(async function (value) {
            this.product_searching = true
            await this.getFormViewModel({
                index: 'products',
                params: {
                    fnName: 'products',
                    search_product: value,
                    product_id: this.model.product_list.map(el => el.product_id)
                }
            })
            this.product_searching = false
        }, 800),
        handleSearchSerial: debounce(async function (value, item) {
            this.serial_searching = true
            await this.getFormViewModel({
                index: 'serials',
                params: {
                    fnName: 'serials',
                    search_serial: value,
                    product_id: item.product_id
                }
            })
            // Add new serials
            if (
                !this.formViewDatas.serials.find(
                    el => el.imei == value || el.serial_no == value
                ) &&
                value
            ) {
                this.formViewDatas.serials.push({
                    product_id: item.product_id,
                    imei: 'New',
                    serial_no: value,
                    purchase_from: 'other',
                })
            }

            this.serial_searching = false
        }, 800),
        getUom(product_id) {
            if (product_id) {
                let product = this.products.find(p => p.value == product_id)
                if (product) {
                    return this.uom.filter(uom => uom.uom_cat_id == product.uom_cat_id)
                }
                return this.uom
            }
            return this.uom
        },
        getSerials(product_id) {
            if (product_id) {
                return this.serials.filter(s => s.product_id == product_id)
            }
            return this.serials
        },
        setProduct(edit_data) {
            let product = this.model.product_list.find(el => el == this.item)

            product.product_id = edit_data.product_id;
            product.uom_id = edit_data.uom_category.unit_of_measures
                .find(el => el.is_default == true).uom_id;
        },
        addNewItem() {
            this.model.product_list.push(clone(this.newItem));
        },
        addNewProduct(item) {
            this.item = item;
            this.show_form = true;
        },
        removeItem(item) {
            this.model.product_list.splice(
                this.model.product_list.indexOf(item),
                1
            );
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "SERVICE TICKET",
                desc: not.text
            });
        }
    },
    watch: {
        validate: function (error) {
            this.errors = new Errors(error.errors);
        }
    }
};
</script>
<style scoped>
.form-control {
    height: 32px !important;
}

textarea::placeholder,
input::placeholder {
    color: #c5c8ce !important;
}
</style>